import styled from "@emotion/styled";

const SearchWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 6px;
`;

export const SearchFiltersWrapper = styled(SearchWrapper)`
  padding: 20px;
  overflow-y: auto;
`;

export const SearchResultsWrapper = styled(SearchWrapper)`
  width: 100%;
`;
